import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hyphen',
})
export class HyphenPipe implements PipeTransform {

  transform(value: any): any {
    return value || '-';
  }

}
